import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Back.module.scss';

const BackButton = ({ onClick, className, children, ...props }) => (
  <button type="button" className={cn(styles.button, className)} onClick={onClick} {...props}>
    <i className="las la-arrow-circle-left" />{children}
  </button>
);

BackButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node
};

BackButton.defaultProps = {
  onClick() {},
  className: '',
  children: null
};

export default BackButton;
